import React, { useCallback, useMemo } from "react";
import { StyleSheet } from "react-native";
import ScreenCard from "../ScreenCard";
import { useI18n } from "../../hooks/i18n-hooks";
import { useTheme } from "../../hooks/use-theme";
import VStack from "../../ui_atoms/VStack";
import { StackScreenProps } from "@react-navigation/stack";
import Text from "../../components/Text";
import SelectRoleImage from "../../assets/images/select-role-image.svg";
import { SignupSigninStackParamList } from "../../navigations/SignupSigninStack";

type SelectRoleScreenProps = StackScreenProps<SignupSigninStackParamList, "SelectRole">;

const SelectRoleScreen = ({ navigation, route }: SelectRoleScreenProps) => {
    const i18n = useI18n();
    const styles = useStyles();
    const { isSignup = false } = route.params || {};

    const goToClientInfo = useCallback(() => {
        navigation.navigate("CheckClientInfo");
    }, [navigation]);

    const goToPrivateClientInfo = useCallback(() => {
        navigation.navigate("CheckPrivateClientInfo");
    }, [navigation]);

    const goToWorkerInfo = useCallback(() => {
        navigation.navigate("CheckWorkerInfo");
    }, [navigation]);

    return (
        <ScreenCard
            headband={
                !isSignup
                    ? { mode: "warning", text: i18n.t("screens.auth.select_role.no_account") }
                    : undefined
            }
            buttons={[
                {
                    title: i18n.t("screens.auth.select_role.client"),
                    onPress: goToClientInfo,
                    mode: "primary",
                },
                {
                    title: i18n.t("screens.auth.select_role.private_client"),
                    onPress: goToPrivateClientInfo,
                    mode: "tertiary",
                },
                {
                    title: i18n.t("screens.auth.select_role.worker"),
                    onPress: goToWorkerInfo,
                    mode: "secondary",
                },
            ]}
            isContentContainerFlex
        >
            <VStack gap={2}>
                <SelectRoleImage width="100%" />
                <Text style={styles.subTitle}>
                    {i18n.t("screens.auth.select_role.description")}
                </Text>
            </VStack>
        </ScreenCard>
    );
};

const useStyles = () => {
    const { fonts } = useTheme();

    return useMemo(
        () =>
            StyleSheet.create({
                subTitle: {
                    ...fonts.titleMedium,
                    marginHorizontal: 18,
                    textAlign: "center",
                },
            }),
        [fonts.titleMedium],
    );
};

export default SelectRoleScreen;
